var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.256 0 0 4.256 0 9.5C0 14.744 4.256 19 9.5 19C14.744 19 19 14.744 19 9.5C19 4.256 14.744 0 9.5 0ZM15.2 11.3715H10.45L12.597 9.2245C12.1568 8.70678 11.6094 8.29084 10.9927 8.00544C10.3759 7.72003 9.70457 7.57198 9.025 7.5715C6.7735 7.5715 4.8925 9.1485 4.408 11.2575L3.496 10.9535C4.104 8.4645 6.346 6.6215 9.025 6.6215C10.716 6.6215 12.2265 7.372 13.2715 8.55L15.2 6.6215V11.3715Z",
    fill: "#5282F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.74e96fa57d34b759d492515b2814201e.svg";
export { ForwardRef as ReactComponent };